import { Card, CardContent, CardHeader, Typography, List, ListItem, ListItemText, Button, Grid, Icon, Box, Dialog, DialogContent, LinearProgress, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AddUserToOrganizationView from './AddUserToOrganizationView';
import { leaveOrganization, removeUserFromOrganization } from '../../services/organizationService';

export default function OrganizationOverview({ organization }) {
  const { name, description, users, ownerName, isOwner } = organization;
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const canLeaveOrganization = !(isOwner && users.length === 1);
  const displayUsers = [];
  console.log(organization);
  if (!organization) {
    return null;
  }
  console.log(users, ownerName);


  function handleAddUsers() {
    console.log("Add User");
    setIsAddUserModalOpen(true);
  }

  function handleCloseAddUserModal() {
    setIsAddUserModalOpen(false);
    window.location.reload();
  }

  function handleLeaveOrganization() {
    if (canLeaveOrganization) {
        alert("You cannot leave an organization you own and have other users in it");
        return;
    }
    const confirmed = window.confirm("Are you sure you want to leave this organization? You will be removed from the organization and will not be able to access any of the organization's resources.");
    if (confirmed) {
      console.log("Left Organization");
      leaveOrganization().then((response) => {
        window.location.reload();
      });
    }
  }

  function handleAddStorage(userId) {
    console.log("Add Storage", userId);
  }

  function handleRemoveUser(userId) {
    console.log("Remove User", userId);

    const confirmed = window.confirm("Are you sure you want to remove this user from the organization? They will no longer have access to the organization's resources.");
    if (confirmed) {
      console.log("Removed User", userId);
      removeUserFromOrganization(userId).then((response) => {
        window.location.reload();   
      });
    }
  }

    return (
    <>
      <Card>
        <CardHeader title="Organization Details" />
        <CardContent>
          <Typography variant="h4" color="text.primary" paragraph>
            {name}
          </Typography>
          <br />
          {users.length > 0 ? (
            <div>
              <Typography variant="h6" gutterBottom>
                Users
              </Typography>
              <br />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Storage</TableCell>
                  {isOwner && <TableCell align="right">Actions</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user) => (
                  <TableRow key={user.username + user.email}>
                    <TableCell>
                      {user.username} {user.isOwner && "(Owner)"}
                    </TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Box sx={{ width: '100%' }}>
                        <LinearProgress
                          variant="determinate"
                          value={(user.usedStorage / user.maxStorage) * 100}
                          sx={{ mb: 1 }}
                        />
                        <Typography variant="body2" color="text.secondary">
                          {`${user.usedStorage} MB / ${user.maxStorage} MB`}
                        </Typography>
                      </Box>
                    </TableCell>
                    {isOwner && (
                      <TableCell align="right">
                        {!user.isOwner && (
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton 
                              size="small" 
                              color="error" 
                              onClick={() => handleRemoveUser(user.id)}
                              title="Remove user from organization"
                            >
                              <DeleteIcon />
                            </IconButton>
                            {/* <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleAddStorage(user.id)}
                              title="Change storage limits"
                            >
                              <AddIcon />
                            </IconButton> */}
                          </Box>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
              <br />
              {isOwner && (
                  <Button variant="contained" color="primary" onClick={() => handleAddUsers()}>Add Users</Button>
              )}
              </div>
          ) : (
              <br/>
          )}
          <br />
          <Button variant="contained" color={canLeaveOrganization ? "primary" : "warning" } disabled={canLeaveOrganization} onClick={() => handleLeaveOrganization()}>Leave Organization</Button>
        </CardContent>
      </Card>

      <Dialog 
        open={isAddUserModalOpen} 
        onClose={() => handleCloseAddUserModal()}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <AddUserToOrganizationView onClose={() => handleCloseAddUserModal()} organizationId={organization.id} />
        </DialogContent>
      </Dialog>
    </>
  );
}
